import { render, staticRenderFns } from "./PriceWorkflowCustomDiscountSignoff.vue?vue&type=template&id=2e30db9c&"
import script from "./PriceWorkflowCustomDiscountSignoff.vue?vue&type=script&lang=js&"
export * from "./PriceWorkflowCustomDiscountSignoff.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports